var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[_c(_setup.FilterApplyDate,{attrs:{"id":"profit_btn_filtropordata"}}),_c(_setup.FilterSearch,{attrs:{"id":"profit_btn_buscar"}}),_c(_setup.FilterExport,{attrs:{"id":"profit_btn_exportar"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }